/**
 * Re-usable functions to manipulate strings
 *
 *
 * @param str string you wish to convert to title case (making first letter capitalized)
 * @returns new string
 */
export function titleCase(str: string): string {
  if (str && str !== '') {
    return str[0].toUpperCase() + str.slice(1).toLowerCase();
  }

  return '';
}
